export const REQUEST_QUESTIONS = 'REQUEST_QUESTIONS'
export const RECEIVE_QUESTIONS = 'RECEIVE_QUESTIONS'
export const REQUEST_SAVE_ANSWERS = 'REQUEST_SAVE_ANSWERS'
export const RECEIVE_SAVE_ANSWERS = 'RECEIVE_SAVE_ANSWERS'
export const REQUEST_SAVE_ANSWERS_PSICO = 'REQUEST_SAVE_ANSWERS_PSICO'
export const RECEIVE_SAVE_ANSWERS_PSICO = 'RECEIVE_SAVE_ANSWERS_PSICO'
